import { ILanguageVO } from 'library/ts/model/language/ILanguageVO';

/**
 * @description Languages database for Audio + CC tracks
 * @type {ILanguageVO[]}
 */
export const Language: ILanguageVO[] = [
	// WARNING: First object in array is dedicated to Unknown language.
	{
		title: '(Unknown)',
		code: 'qq',
		altCode: 'und'
	},
	{
		title: 'Afrikaans',
		code: 'af',
		altCode: 'afr'
	},
	{
		title: 'Albanian',
		code: 'sq',
		altCode: 'sqi'
	},
	{
		title: 'Amharic',
		code: 'am',
		altCode: 'amh'
	},
	{
		title: 'Arabic',
		code: 'ar',
		altCode: 'ara'
	},
	{
		title: 'Armenian',
		code: 'hy',
		altCode: 'hye'
	},
	{
		title: 'Assamese',
		code: 'as',
		altCode: 'asm'
	},
	{
		title: 'Azeri',
		code: 'az',
		altCode: 'aze'
	},
	{
		title: 'Basque',
		code: 'eu',
		altCode: 'eus'
	},
	{
		title: 'Belarusian',
		code: 'be',
		altCode: 'bel'
	},
	{
		title: 'Bengali',
		code: 'bn',
		altCode: 'ben'
	},
	{
		title: 'Bosnian',
		code: 'bs',
		altCode: 'bos'
	},
	{
		title: 'Bulgarian',
		code: 'bg',
		altCode: 'bul'
	},
	{
		title: 'Burmese',
		code: 'my',
		altCode: 'mya'
	},
	{
		title: 'Cantonese',
		code: 'yue',
		altCode: 'yue'
	},
	{
		title: 'Catalan',
		code: 'ca',
		altCode: 'cat'
	},
	{
		title: 'Cherokee',
		code: 'chr',
		altCode: 'chr'
	},
	{
		title: 'Chinese',
		code: 'zh',
		altCode: 'zho'
	},
	{
		title: 'Chinese (Simplified)',
		code: 'zh-Hans',
		altCode: 'zh-CN'
	},
	{
		title: 'Chinese (Traditional)',
		code: 'zh-Hant',
		altCode: 'zh-TW'
	},
	{
		title: 'Chinese (Traditional HK)',
		code: 'zh-Hant-HK',
		altCode: 'zh-HK'
	},
	{
		title: 'Creole',
		code: 'ht',
		altCode: 'hat'
	},
	{
		title: 'Croatian',
		code: 'hr',
		altCode: 'hrv'
	},
	{
		title: 'Czech',
		code: 'cs',
		altCode: 'ces'
	},
	{
		title: 'Danish',
		code: 'da',
		altCode: 'dan'
	},
	{
		title: 'Divehi',
		code: 'dv',
		altCode: 'div'
	},
	{
		title: 'Dutch',
		code: 'nl',
		altCode: 'nld'
	},
	{
		title: 'Dzongkha',
		code: 'dz',
		altCode: 'dzo'
	},
	{
		title: 'Edo',
		code: 'bin',
		altCode: 'bin'
	},
	{
		title: 'English',
		code: 'en',
		altCode: 'eng'
	},
	{
		title: 'English (Australia)',
		code: 'en-AU',
		altCode: 'eng-AU'
	},
	{
		title: 'English (Canada)',
		code: 'en-CA',
		altCode: 'eng-CA'
	},
	{
		title: 'British English',
		code: 'en-GB',
		altCode: 'eng-GB'
	},
	{
		title: 'English (Ireland)',
		code: 'en-IE',
		altCode: 'eng-IE'
	},
	{
		title: 'English (New Zealand)',
		code: 'en-NZ',
		altCode: 'eng-NZ'
	},
	{
		title: 'English (U.K.)',
		code: 'en-UK',
		altCode: 'eng-UK'
	},
	{
		title: 'English (U.S.)',
		code: 'en-US',
		altCode: 'eng-US'
	},
	{
		title: 'Estonian',
		code: 'et',
		altCode: 'est'
	},
	{
		title: 'Faeroese',
		code: 'fo',
		altCode: 'fao'
	},
	{
		title: 'Farsi',
		code: 'fa',
		altCode: 'fas'
	},
	{
		title: 'Filipino',
		code: 'fil',
		altCode: 'fil'
	},
	{
		title: 'Finnish',
		code: 'fi',
		altCode: 'fin'
	},
	{
		title: 'French',
		code: 'fr',
		altCode: 'fra'
	},
	{
		title: 'French (Canadian)',
		code: 'fr-CA',
		altCode: 'fr-CA'
	},
	{
		title: 'Frisian',
		code: 'fy',
		altCode: 'fry'
	},
	{
		title: 'Fulfulde',
		code: 'ff',
		altCode: 'ful'
	},
	{
		title: 'Galician',
		code: 'gl',
		altCode: 'glg'
	},
	{
		title: 'Georgian',
		code: 'ka',
		altCode: 'kat'
	},
	{
		title: 'German',
		code: 'de',
		altCode: 'deu'
	},
	{
		title: 'Greek',
		code: 'el',
		altCode: 'ell'
	},
	{
		title: 'Guarani',
		code: 'gn',
		altCode: 'grn'
	},
	{
		title: 'Gujarati',
		code: 'gu',
		altCode: 'guj'
	},
	{
		title: 'Hausa',
		code: 'ha',
		altCode: 'hau'
	},
	{
		title: 'Hawaiian',
		code: 'haw',
		altCode: 'haw'
	},
	{
		title: 'Hebrew',
		code: 'he',
		altCode: 'heb'
	},
	{
		title: 'Hindi',
		code: 'hi',
		altCode: 'hin'
	},
	{
		title: 'Hungarian',
		code: 'hu',
		altCode: 'hun'
	},
	{
		title: 'Ibibio',
		code: 'ibb',
		altCode: 'ibb'
	},
	{
		title: 'Icelandic',
		code: 'is',
		altCode: 'isl'
	},
	{
		title: 'Igbo',
		code: 'ig',
		altCode: 'ibo'
	},
	{
		title: 'Indonesian',
		code: 'id',
		altCode: 'ind'
	},
	{
		title: 'Inuktitut',
		code: 'iu',
		altCode: 'iku'
	},
	{
		title: 'Inupiak',
		code: 'ik',
		altCode: 'ipk'
	},
	{
		title: 'Irish',
		code: 'ga',
		altCode: 'gle'
	},
	{
		title: 'Italian',
		code: 'it',
		altCode: 'ita'
	},
	{
		title: 'Japanese',
		code: 'ja',
		altCode: 'jpn'
	},
	{
		title: 'Kannada',
		code: 'kn',
		altCode: 'kan'
	},
	{
		title: 'Kanuri',
		code: 'kr',
		altCode: 'kau'
	},
	{
		title: 'Kashmiri',
		code: 'ks',
		altCode: 'kas'
	},
	{
		title: 'Kazakh',
		code: 'kk',
		altCode: 'kaz'
	},
	{
		title: 'Khmer',
		code: 'km',
		altCode: 'khm'
	},
	{
		title: 'Kirundi/Kinyarwanda',
		code: 'rn',
		altCode: 'run'
	},
	{
		title: 'Konkani',
		code: 'kok',
		altCode: 'kok'
	},
	{
		title: 'Korean',
		code: 'ko',
		altCode: 'kor'
	},
	{
		title: 'Kurdish',
		code: 'ku',
		altCode: 'kur'
	},
	{
		title: 'Kyrgyz',
		code: 'ky',
		altCode: 'kir'
	},
	{
		title: 'Lao',
		code: 'lo',
		altCode: 'lao'
	},
	{
		title: 'Latin',
		code: 'la',
		altCode: 'lat'
	},
	{
		title: 'Latvian',
		code: 'lv',
		altCode: 'lav'
	},
	{
		title: 'Lithuanian',
		code: 'lt',
		altCode: 'lit'
	},
	{
		title: 'Macedonian',
		code: 'mk',
		altCode: 'mkd'
	},
	{
		title: 'Malagasy',
		code: 'mg',
		altCode: 'mlg'
	},
	{
		title: 'Malay',
		code: 'ms',
		altCode: 'msa'
	},
	{
		title: 'Malayalam',
		code: 'ml',
		altCode: 'mal'
	},
	{
		title: 'Maltese',
		code: 'mt',
		altCode: 'mlt'
	},
	{
		title: 'Mandarin',
		code: 'cmn',
		altCode: 'cmn'
	},
	{
		title: 'Manipuri',
		code: 'mni',
		altCode: 'mni'
	},
	{
		title: 'Marathi',
		code: 'mr',
		altCode: 'mar'
	},
	{
		title: 'Mongolian',
		code: 'mn',
		altCode: 'mon'
	},
	{
		title: 'Ndebele',
		code: 'nd',
		altCode: 'nde'
	},
	{
		title: 'Nepali',
		code: 'ne',
		altCode: 'nep'
	},
	{
		// https://github.com/date-fns/date-fns/issues/2963
		title: 'Norwegian',
		code: 'nb',
		altCode: 'nn'
	},
	{
		title: 'Norwegian',
		code: 'no',
		altCode: 'nor'
	},
	{
		title: 'Oriya',
		code: 'or',
		altCode: 'ori'
	},
	{
		title: 'Oromo',
		code: 'om',
		altCode: 'orm'
	},
	{
		title: 'Pashto',
		code: 'ps',
		altCode: 'pus'
	},
	{
		title: 'Polish',
		code: 'pl',
		altCode: 'pol'
	},
	{
		title: 'Portuguese',
		code: 'pt',
		altCode: 'por'
	},
	{
		title: 'Portuguese (Brazil)',
		code: 'pt-BR',
		altCode: 'por-BR'
	},
	{
		title: 'Punjabi',
		code: 'pa',
		altCode: 'pan'
	},
	{
		title: 'Quechua',
		code: 'qu',
		altCode: 'que'
	},
	{
		title: 'Rhaeto-Romanic',
		code: 'rm',
		altCode: 'roh'
	},
	{
		title: 'Romanian',
		code: 'ro',
		altCode: 'ron'
	},
	{
		title: 'Russian',
		code: 'ru',
		altCode: 'rus'
	},
	{
		title: 'Sami',
		code: 'se',
		altCode: 'smi'
	},
	{
		title: 'Sanskrit',
		code: 'sa',
		altCode: 'san'
	},
	{
		title: 'Scottish Gaelic',
		code: 'gd',
		altCode: 'gla'
	},
	{
		title: 'Serbian',
		code: 'sr',
		altCode: 'srp'
	},
	{
		title: 'Shona',
		code: 'sn',
		altCode: 'sna'
	},
	{
		title: 'Sindhi',
		code: 'sd',
		altCode: 'snd'
	},
	{
		title: 'Sinhalese',
		code: 'si',
		altCode: 'sin'
	},
	{
		title: 'Slovak',
		code: 'sk',
		altCode: 'slk'
	},
	{
		title: 'Slovenian',
		code: 'sl',
		altCode: 'slv'
	},
	{
		title: 'Somali',
		code: 'so',
		altCode: 'som'
	},
	{
		title: 'Sorbian',
		code: 'wen',
		altCode: 'wen'
	},
	{
		title: 'Spanish',
		code: 'es',
		altCode: 'spa'
	},
	{
		title: 'Spanish (Latin America)',
		code: 'es-MX',
		altCode: 'las'
	},
	{
		title: 'Spanish (U.S.)',
		code: 'es-US',
		altCode: 'spa-US'
	},
	{
		title: 'Sutu',
		code: 'st',
		altCode: 'sot'
	},
	{
		title: 'Swahili',
		code: 'sw',
		altCode: 'swa'
	},
	{
		title: 'Swedish',
		code: 'sv',
		altCode: 'swe'
	},
	{
		title: 'Syriac',
		code: 'syr',
		altCode: 'syr'
	},
	{
		title: 'Tajik',
		code: 'tg',
		altCode: 'tgk'
	},
	{
		title: 'Tamazight',
		code: 'tzm',
		altCode: 'tzm'
	},
	{
		title: 'Tamil',
		code: 'ta',
		altCode: 'tam'
	},
	{
		title: 'Tatar',
		code: 'tt',
		altCode: 'tat'
	},
	{
		title: 'Telugu',
		code: 'te',
		altCode: 'tel'
	},
	{
		title: 'Thai',
		code: 'th',
		altCode: 'tha'
	},
	{
		title: 'Tibetan',
		code: 'bo',
		altCode: 'bod'
	},
	{
		title: 'Tigrigna',
		code: 'ti',
		altCode: 'tir'
	},
	{
		title: 'Tsonga',
		code: 'ts',
		altCode: 'tso'
	},
	{
		title: 'Tswana',
		code: 'tn',
		altCode: 'tsn'
	},
	{
		title: 'Turkish',
		code: 'tr',
		altCode: 'tur'
	},
	{
		title: 'Turkmen',
		code: 'tk',
		altCode: 'tuk'
	},
	{
		title: 'Ukrainian',
		code: 'uk',
		altCode: 'ukr'
	},
	{
		title: 'Urdu',
		code: 'ur',
		altCode: 'urd'
	},
	{
		title: 'Uzbek',
		code: 'uz',
		altCode: 'uzb'
	},
	{
		title: 'Venda',
		code: 've',
		altCode: 'ven'
	},
	{
		title: 'Vietnamese',
		code: 'vi',
		altCode: 'vie'
	},
	{
		title: 'Welsh',
		code: 'cy',
		altCode: 'cym'
	},
	{
		title: 'Xhosa',
		code: 'xh',
		altCode: 'xho'
	},
	{
		title: 'Yi',
		code: 'ii',
		altCode: 'iii'
	},
	{
		title: 'Yiddish',
		code: 'yi',
		altCode: 'yid'
	},
	{
		title: 'Yoruba',
		code: 'yo',
		altCode: 'yor'
	},
	{
		title: 'Zulu',
		code: 'zu',
		altCode: 'zul'
	},
	{
		title: '(Other)',
		code: 'zz',
		altCode: 'mis'
	}
];

/**
 * @description Returns default ILanguageLabel object with matching code or altCode
 * @param {string} code
 * @param {ILanguageVO[]} languageLabels - default or override list of languages
 * @returns {ILanguageVO}
 */
export const getLanguageLabelByCode = ( code: string, languageLabels: ILanguageVO[] = Language ): ILanguageVO => {
	return getLanguageLabelByCodeExecutor( code, languageLabels );
};

/**
 * @description Returns ILanguageLabel object with matching code or altCode from languageLabels array
 * @param {string} code
 * @param {ILanguageVO[]} languageLabels
 * @return {ILanguageVO}
 */
const getLanguageLabelByCodeExecutor = ( code: string, languageLabels: ILanguageVO[] = Language ): ILanguageVO => {
	const utils = window?.PARA?.PlayerServices?.Utilities;

	// null check
	if ( utils.Type.isEmpty( code ) ) return;

	// return fallback ILanguageLabel if no match found
	const fallbackLanguage: ILanguageVO = {
		title: ( utils.Type.isArray( languageLabels ) && languageLabels.length > 0 ? languageLabels[ 0 ]?.title : '(Unknown)' ),
		code: code,
		altCode: code
	};
	if ( !languageLabels ) return fallbackLanguage;

	const matchingCode = code.toLowerCase();
	return languageLabels.find( ( language ) => language?.code?.toLowerCase() === matchingCode || language?.altCode?.toLowerCase() === matchingCode ) || fallbackLanguage;
};